/*
 * @Description: 路由页面管理
 * @Autor: Popper_Li
 */

/**
 * 定义的页面列表，会按照vue-router的要求转换成其所需的格式
 * 在没有name/path的时候，key会默认对应它们
 * 配置说明：{
 *   name,                                     // 配置路由的name 默认为当前对象的Key
 *   path,                                     // 配置路由的path 默认为当前对象的`/${Key}`
 *   meta:{                                    // 转换成meta
 *      title                                  // 页面标题
 *      keepAlive                              // 当前页面是否开启缓存
 *   },
 *   setting:{},                               // 项目设置，配置文档参照'@const/setting.js'
 *   orSyncApiList:[]                          // 在webview下，初始进来调用哪些action
 * }
 */

const PAGES = {
  Index: { path: '/', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  AboutMingAn: { path: '/AboutMingAn', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  NewsInformation: { path: '/NewsInformation', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  ContactUs: { path: '/ContactUs', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  BusinessBuilding: { path: '/BusinessBuilding', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  HealthBusiness: { path: '/HealthBusiness', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  RichText: { path: '/RichText', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  GoneDetail: { path: '/GoneDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  GtwoDetail: { path: '/GtwoDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  FoneDetail: { path: '/FoneDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  FtwoDetail: { path: '/FtwoDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  XoneDetail: { path: '/XoneDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  XtwoDetail: { path: '/XtwoDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  KoneDetail: { path: '/KoneDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  KtwoDetail: { path: '/KtwoDetail', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  CorporateCulture: { path: '/CorporateCulture', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
  SocialDuty: { path: '/SocialDuty', meta: { title: '浙江铭安', keepAlive: true }, setting: {} },
}

export const pagesSetting = {}
const pages = []
for (const key in PAGES) {
  const { setting = {}, meta } = PAGES[key];
  let { path = '', name = '' } = PAGES[key];
  pagesSetting[key] = { ...setting }
  if (!name) name = key
  if (!path) path = `/${key}`
  pages.push({
    path,
    name,
    meta,
    component: () => import(`@/views/${key}`)
  })
}
export default pages